import { ADDITIONAL_ROUTE, HOME_PAGES_ROUTES } from "constants/routes";

import { isLocal } from "constants/env-constants";
import { type Fields, type QueryParams, buildURLwithQueryParams } from "utils/urlBuilder";

// Redirect to the page to perform login via IDP
const redirectToIdpLogin = (queryParamsPath: QueryParams): void => {
  const additionalsQueryParamsPath =
    queryParamsPath && Object.keys(queryParamsPath).length
      ? { ...queryParamsPath, state: `${ADDITIONAL_ROUTE}${queryParamsPath.state}` }
      : ({ state: ADDITIONAL_ROUTE } as QueryParams);
  const arrayQueryParams = Object.keys(additionalsQueryParamsPath).map((key) => ({
    key,
    value: additionalsQueryParamsPath[key],
  })) as Fields[];
  const url = "/idp-signin";
  const newUrl = Object.keys(arrayQueryParams).length
    ? buildURLwithQueryParams(url, arrayQueryParams)
    : url;
  window.location.href = newUrl;
};

// Redirect to page that cleans up IDP generated cookies
const redirectToIdpLogout = (prevPath?: string): void => {
  const state =
    prevPath === HOME_PAGES_ROUTES.HOME_PAGE ||
    prevPath === `${ADDITIONAL_ROUTE}${HOME_PAGES_ROUTES.HOME_PAGE}`
      ? ""
      : prevPath;
  const additionalsUrl = isLocal() ? "/idp-logout" : `${ADDITIONAL_ROUTE}/idp-logout`;
  const statesWithoutAdditionals = state ? state.slice(state.indexOf("/", 1)) : "";
  const url = statesWithoutAdditionals
    ? `${additionalsUrl}?state=${statesWithoutAdditionals}`
    : additionalsUrl;
  window.location.href = url;
};

export { redirectToIdpLogin, redirectToIdpLogout };
